module.exports = { css: `

` };